var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styles)},[_c('h1',{style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.item.title))]),_c('div',[_c('h1',{style:(_vm.bodyStyle)},[_vm._v(_vm._s(_vm.item.body))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }